//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardPropertyIcon from './CardPropertyIcon.vue'
import { cardPropertyMixin } from './CardPropertyMixin.js'

export default {
  name: 'CardPropertyDefault',
  components: {
    CardPropertyIcon
  },
  mixins: [cardPropertyMixin],
  props: {
    tabProp: {
      type: Object,
      default: null
    },
    object: {
      type: Object,
      default: null
    }
  },
  computed: {
    value: function () {
      if (this.object && this.tabProp) {
        const propData = this.object[this.tabProp.key]
        if (propData) {
          if (typeof propData === 'object') {
            return JSON.stringify(propData)
          } else {
            return propData
          }
        }
      }
      return null
    }
  }
}
